import React, { useState, useEffect } from "react";
import { Modal, Box, IconButton, TextField, Checkbox, ListItemText } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import SelectInput from "../SelectInput";
import { GenerateAgeOptions, MAX_AGE, MIN_AGE } from "../../constants/profileData";
import HeightFilter from "./HeightFilter";
import { SELECT_ALL_FILTER } from "../../constants/filters";

const MobileFilterRenderer = ({
    filterState,
    setFilterState,
    currentSelectedFilter, 
    setCurrentSelectedFilter,
    handleCheckboxChange, 
    applyProfileFilter,
    resetFilters,
    searchQuery,
    handleSearchChange,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => {
    setModalOpen(false);
    setCurrentSelectedFilter("");
  }
  useEffect(()=> {
    if(currentSelectedFilter !== "" && isModalOpen === false)
        openModal();
  }, [currentSelectedFilter])
  const currentFilter = filterState[currentSelectedFilter];

  return (
    <>
      {/* Mobile Filter Button */}
        <div style={{ marginTop: "20px" }}>
            <button
                className="bg-blue-500 text-white px-4 py-2 rounded-lg m-1"
                onClick={openModal}
            >
            Update Filters
            </button>
            <button
                className="bg-blue-500 text-white px-4 py-2 rounded-lg m-1"
                onClick={() => applyProfileFilter()}
            >
            Apply
            </button>
        </div>

      {/* Modal for Filters */}
      <Modal open={isModalOpen} onClose={closeModal}>
        <Box
           sx={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "95vw",
            height: "100%",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",  // Prevents full-page scroll
          }}
        >
          <div className="flex justify-between items-center px-4 py-3 border-b">
            <h2>Filters</h2>
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>

          {/* Render all Filter categories */}
          <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
            <div
              style={{
                width: "40%",
                borderRight: "1px solid #e0e0e0",
                overflowY: "auto",
                padding: "10px",
              }}
            >
                {Object.keys(filterState).map((filterKey) => {
                    var filterLabel;
                    //  For height and age filters, state consists only of value and no name
                    if (filterKey === "heightFilterState") {
                        filterLabel = "Height";
                    } else if(filterKey === "ageFilterState"){
                        filterLabel="Age";
                    } else {
                        filterLabel = filterState[filterKey].filterName;
                    }
      
                      return (
                        <div
                          key={filterKey}
                          onClick={() => setCurrentSelectedFilter(filterKey)}
                          style={{
                            padding: "8px 12px",
                            marginBottom: "6px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            backgroundColor:
                              currentSelectedFilter === filterKey ? "#007bff20" : "transparent", // Light blue background for selected filter
                            color: currentSelectedFilter === filterKey ? "#007bff" : "#000", // Blue text for selected filter
                            fontWeight: currentSelectedFilter === filterKey ? "bold" : "normal",
                            textAlign: "left",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={filterLabel} // Tooltip for truncated text
                        >
                          {filterLabel}
                        </div>
                      );
                })}
            </div>

            {/*Render Selected filter's options */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "16px",
              }}
            >
              {currentSelectedFilter === "heightFilterState" ? (
                <HeightFilter filterState={filterState} setFilterState={setFilterState} isMobile={true} />
              ) : currentSelectedFilter === "ageFilterState" ? (
                <Box display="flex" flexDirection="column" gap={2} width="100%">
                  <SelectInput
                    name="minAge"
                    label="Min Age"
                    value={filterState.ageFilterState[0].toString()} // Convert to string for Select
                    handleChange={(event) => {
                      const value = Number(event.target.value);
                      setFilterState({
                        ...filterState,
                        ageFilterState: [value, filterState.ageFilterState[1]],
                      });
                    }}
                    options={GenerateAgeOptions(MIN_AGE, filterState.ageFilterState[1] - 1)}
                  />
                  <SelectInput
                    name="maxAge"
                    label="Max Age"
                    value={filterState.ageFilterState[1].toString()} // Convert to string for Select
                    handleChange={(event) => {
                      const value = Number(event.target.value);
                      setFilterState({
                        ...filterState,
                        ageFilterState: [filterState.ageFilterState[0], value],
                      });
                    }}
                    options={GenerateAgeOptions(filterState.ageFilterState[0] + 1, MAX_AGE)}
                  />
                </Box>
              ) : currentFilter !== undefined && currentFilter !== null ? (
                // Handle general filters (checkbox-based)
                <Box>
                  <TextField
                    variant="outlined"
                    label={`Search ${filterState[currentSelectedFilter].filterName}`}
                    fullWidth
                    size="small"
                    value={searchQuery[currentSelectedFilter] || ""}
                    onChange={(e) => handleSearchChange(currentSelectedFilter, e.target.value)}
                  />
                  <div style={{ marginTop: 10 }}>
                    {filterState[currentSelectedFilter].enableSelectAll && (
                      <div key={`${currentSelectedFilter}-selectall`} style={{ display: "flex", alignItems: "center" }}>
                        <Checkbox
                          checked={filterState[currentSelectedFilter].selectedCount === filterState[currentSelectedFilter].filters.length}
                          onChange={() => handleCheckboxChange(currentSelectedFilter, SELECT_ALL_FILTER)}
                        />
                        <ListItemText primary={SELECT_ALL_FILTER} />
                      </div>
                    )}
                    {filterState[currentSelectedFilter].filters
                      .filter((item) => item.label.toLowerCase().includes((searchQuery[currentSelectedFilter] || "").toLowerCase()))
                      .map((option) => (
                        <div key={option.label} style={{ display: "flex", alignItems: "center" }}>
                          <Checkbox
                            checked={option.checked}
                            onChange={() => handleCheckboxChange(currentSelectedFilter, option)}
                          />
                          <ListItemText primary={option.label} />
                        </div>
                      ))}
                  </div>
                </Box>
              ) : (<></>)}              
            </div>
          </div>

          {/* Footer Buttons */}
          <div
            style={{
              padding: "16px",
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              justifyContent: "space-between",
              position: "sticky",     // Keep it fixed at the bottom
              bottom: 0,
            }}
          >
            <button
              className="bg-gray-300 px-4 py-2 rounded-lg w-1/2 mr-2"
              onClick={resetFilters}
            >
              Clear Filters
            </button>
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded-lg w-1/2 ml-2"
              onClick={() => {
                applyProfileFilter();
                closeModal();
              }}
            >
              Apply
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default MobileFilterRenderer;